import * as React from 'react';
import { Box, Avatar, Menu, MenuItem, Divider, IconButton, Tooltip } from '@material-ui/core';
import ModeTheme2 from '../ModeTheme/ModeTheme2';
import Logout2 from '../Logout/Logout2'
import Cookies from "universal-cookie";

const cookies = new Cookies();
const user = cookies.get("user");  

function stringToColor(string) {
	let hash = 0;
	let i;
      
	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
	  hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}
      
	let color = '#';
      
	for (i = 0; i < 3; i += 1) {
	  const value = (hash >> (i * 8)) & 0xff;
	  color += `00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */
      
	return color;
      }

function stringAvatar(name) {
	return {
	  sx: {
	    bgcolor: stringToColor(name),
	    color: 'white'
	  },
	  children: `${name.split(' ')[0][0]}${name.split(' ')[1] ? name.split(' ')[1][0] : ''}`.toUpperCase(),
	};
      }

export default function AccountMenu() {
	// const cartContext = React.useContext(CartContext);
	// const {user}= cartContext;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
	<>
	{ true ?
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Cuenta y preferencias">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            aria-label={`Abrir cuenta de ${user || 'usuario'}`}
          >
            <Avatar sx={{ width: 32, height: 32, color: 'inherit', }} {...stringAvatar(`${user}`)}></Avatar>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>
          <Avatar /> {user}
        </MenuItem>
        <Divider />
        	<ModeTheme2/>
        	<Logout2/>
      </Menu>
    </React.Fragment>
	:
	<></>
	}
    </>
  );
}
